import React from 'react';
import Footer from './Footer';
import { Container } from 'react-bootstrap';
import './About.css';
import { useEffect } from 'react';

function About  ()  {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);
    return (
        <>
            <Container style={{marginTop:'10frem'}}  className='about__container__aim'>
                <div>
                    <img src='https://cdn2.iconfinder.com/data/icons/market-research-shades-vol-2/128/OBJECTIVE-512.png' className='about__img' alt='' />
                </div>
                <div>
                    <p className='about__aim'>
                    Our mission at QuickLearn is to facilitate seamless access to educational resources, empowering learners to excel in their academic pursuits. We believe that every student deserves access to high-quality learning materials, regardless of their geographical location or financial constraints.
                    </p>
                </div>
            </Container>

            <br/> <br/> <br/>

            <Container style={{marginTop:'2rem'}}>
                <h2>What We Offer</h2>
                <p>At QuickLearn, we offer an extensive library of textbooks, notes, and previous year papers across various disciplines and academic levels. Our platform is designed with user experience in mind, providing intuitive navigation and advanced search capabilities.</p>
            </Container>

            <Container>
            <div className='row'>
                        <div class="col">
                            <li style={{listStyle:'none'}}>
                                 <button className='news_url diagonal-hoverr' style={{height:'200px'}}> <div className='contentt' style={{fontSize:'15px', marginTop:'-1rem'}}> To enable students to upload and share their own engineering notes, creating a collaborative learning environment. </div> </button>
                            </li>
                        </div>
                        <div class="col">
                        <li style={{listStyle:'none'}}>
                            <a href='https://rtu.ac.in/index/view_menudata.php?page=Time-Table29' > <button className='news_url diagonal-hoverr' style={{height:'200px'}}> <div className='contentt' style={{fontSize:'15px', marginTop:'-1rem'}}> To provide a repository of previous year question papers for engineering exams, allowing students to access valuable resources for exam preparation. </div> </button> </a>
                        </li>
                        </div>
                        <div class="col">
                            <li style={{listStyle:'none'}}>
                                <a href='https://rtu.sumsraj.com/' ><button className='news_url diagonal-hoverr' style={{height:'200px'}}> <div className='contentt' style={{fontSize:'15px', marginTop:'-1rem'}}> To foster a sense of community and knowledge-sharing among engineering students by facilitating the exchange of notes and resources. </div> </button> </a>
                            </li>
                        </div>
                        </div>
            </Container>

            <br/> <br/>

            <Container>
                <h3>Get Involved !</h3>
                <p>
                Are you passionate about education? Do you have expertise in a particular subject? Consider contributing to QuickLearn! We welcome educators, scholars, and enthusiasts to join us in our mission of making education accessible to all.
                </p>
            </Container>
            <br/>

            <Container>
                <p>Have questions or feedback? We'd love to hear from you! Get in touch with us via <a href='mailto:quicklearn-rtu@gmail.com'> email </a> or social media. Your input helps us improve and grow, ensuring that QuickLearn remains a valuable resource for learners worldwide.</p>
            </Container>
            <br/>
            <hr/>
            <Footer/>    
        </>
    );
}

export default About;
